module.exports = __webpack_public_path__ + "img/1@3x.45fb0f64.png";